import React, { useState } from "react";
import "./Cart.scss";
import Navbar from "../../components/Navbar/Navbar";
import Banner from "../../components/banner/Banner";
import Footer from "../../components/Footer/Footer";
import { Link } from "react-router-dom";
import { BsChevronRight } from "react-icons/bs";
import cartShipping from "../../assets/cartShipping.svg";
import TableWrapper from "../../components/Table/Table";
import { tableFive } from "../../tableSettings";
import emptyCart from "../../assets/tabler-icon-shopping-cart-off.svg";
import { AiOutlineHome } from "react-icons/ai";
import Dropdown from "../../components/Navbar/Dropdown";

import { useDispatch, useSelector } from "react-redux";
import {
  decrementQuantity,
  incrementQuantity,
  removeItem,
} from "../../Redux/cartSlice";
import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { domain } from "../../config";

const Cart = () => {
  const cart = useSelector((state) => state.cart.products);
  const dispatch = useDispatch();
  const [totalCartP, setTotalcartP] = useState(0);

  const handleDecrement = (item) => {
    dispatch(decrementQuantity(item));
  };
  const handleIncrement = (item) => {
    dispatch(incrementQuantity(item));
  };
  const handleRemove = (item) => {
    dispatch(removeItem(item));
  };

  useEffect(() => {
    const getTotalCart = () => {
      if (cart.length) {
        const totalAmount = cart.reduce(
          (prev, current) =>
            prev +
            current.quantity *
              (current.on_sale ? current.sale_price : current.price),
          0
        );
        setTotalcartP(Math.round(totalAmount * 100) / 100);
      }
    };
    getTotalCart();
  }, [cart]);

  return (
    <div className="cart">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Cart </title>
        <link rel="canonical" href={`${domain}/cart`} />
      </Helmet>
      <Banner />
      <Navbar />
      <Dropdown />
      <div className="cart-wrapper">
        {cart.length !== 0 ? (
          <div className="cart-details">
            <div className="cart-main-container">
              <div className="current-path-link">
                <div className="links">
                  <Link
                    to="/"
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}>
                    <AiOutlineHome
                      style={{
                        fontSize: "22px",
                        paddingRight: "8px",
                      }}
                    />
                    Home
                  </Link>
                  <BsChevronRight />
                  <Link to="/categories">Shop</Link>
                  <BsChevronRight />
                  <Link to="/cart">cart</Link>
                </div>
                <div className="shipping-info">
                  <img src={cartShipping} alt="icon" />
                  <h1>Shipping options will be updated during checkout.</h1>
                </div>
              </div>
              <div className="cart-summary">
                <TableWrapper
                  data={cart}
                  columns={tableFive}
                  handleIncrement={handleIncrement}
                  handleDecrement={handleDecrement}
                  handleRemove={handleRemove}
                  cut={true}
                />
              </div>
            </div>
            <div className="coupon-div">
              <div className="coupon-input">
                <input placeholder="Enter coupon code" type="text" />
                <button className="apply-coupon">Apply Coupon</button>
              </div>
              <Link to="/checkout" className="checkout-button">
                <span>Continue to Checkout</span>
                <div className="line"></div>
                <span className="total">${totalCartP}</span>
              </Link>
            </div>
          </div>
        ) : (
          <div className="empty-cart">
            <img src={emptyCart} alt="empty-cartIcon" />
            <div className="text-wrapper">
              <span className="textOne">No products yet!</span>
              <span className="slogan">
                Visit the shop page and buy supplements of your choice!
              </span>
            </div>
            <Link to="/categories" className="shop-button">
              Go to Shop
            </Link>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Cart;
